export default function Events() {
  return (
    <section id="events">
      <div className="reveal">
        <div className="sec-label"> Events We Plan</div>
        <h2 className="sec-title">
          Every celebration,<br />
          <em>every occasion.</em>
        </h2>
      </div>

      <div className="events-grid">
        <div className="event-card reveal">
          <span className="event-icon">💍</span>
          <div className="event-title">Weddings</div>
          <p className="event-desc">
            From small intimate ceremonies to large traditional weddings —
            every detail managed with care and elegance.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-1">
          <span className="event-icon">💎</span>
          <div className="event-title">Engagements &amp; Betrothals</div>
          <p className="event-desc">
            Ring ceremonies, Roka, Nishchitartham, Pellipandiri —
            we make your engagement truly memorable.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-2">
          <span className="event-icon">🎂</span>
          <div className="event-title">Birthdays</div>
          <p className="event-desc">
            First birthdays, milestone 18th and 50th parties,
            themed kids' parties — we plan them all beautifully.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-3">
          <span className="event-icon">👶</span>
          <div className="event-title">Baby Showers &amp; Naming</div>
          <p className="event-desc">
            Baby showers, cradle ceremonies, Namakarana,
            and naming events filled with warmth and joy.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-1">
          <span className="event-icon">🌸</span>
          <div className="event-title">Puberty Ceremonies</div>
          <p className="event-desc">
            Half-saree functions and puberty celebrations
            planned traditionally and beautifully.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-2">
          <span className="event-icon">🏠</span>
          <div className="event-title">Housewarming</div>
          <p className="event-desc">
            Griha Pravesh and housewarming celebrations —
            puja arrangements, catering, decor and guests sorted.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-3">
          <span className="event-icon">🎊</span>
          <div className="event-title">Anniversary Parties</div>
          <p className="event-desc">
            Silver jubilees, golden anniversaries,
            and surprise parties — planned with love.
          </p>
        </div>

        <div className="event-card reveal reveal-delay-4">
          <span className="event-icon">🏢</span>
          <div className="event-title">Corporate &amp; Office Events</div>
          <p className="event-desc">
            Team outings, launches, award nights,
            and conferences managed professionally.
          </p>
        </div>
      </div>
    </section>
  );
}